(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Vue"));
	else if(typeof define === 'function' && define.amd)
		define("eiip", ["Vue"], factory);
	else if(typeof exports === 'object')
		exports["eiip"] = factory(require("Vue"));
	else
		root["eiip"] = factory(root["Vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__62508__) {
return 